import React from "react";
import logo from "../assets/images/logo.png";
import "../assets/styles/sessionLoader.css";

/*
 * Full-screen branded loader shown while the admin session is checked.
 * Used by both the protected and the public (login) routes.
 */
const SessionLoader = ({ label = "Checking your session" }) => (
  <div
    className="session-loader-screen"
    role="status"
    aria-live="polite"
    aria-label={label}
  >
    <div className="session-loader-card" aria-hidden="true">
      <div className="session-loader-emblem">
        <span className="session-loader-ring session-loader-ring-outer" />
        <span className="session-loader-ring session-loader-ring-inner" />

        <span className="session-loader-logo">
          <img src={logo} alt="" />
        </span>
      </div>

      <div className="session-loader-text">
        <strong>Wedding Stationery</strong>
        <span>{label}</span>
      </div>

      <div className="session-loader-dots">
        <span />
        <span />
        <span />
      </div>
    </div>

    <span className="session-loader-accessible-text">{label}</span>
  </div>
);

export default SessionLoader;
